import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import "./CanonsOfConductDialog.scss";

const CanonsOfConductDialog = ({
  open,
  onClose,
  canons,
  onAccept,
  mandatory = false,
  accepted = false,
}) => {
  const [localAccepted, setLocalAccepted] = React.useState(accepted);

  const handleAccept = () => {
    onAccept();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
      className="canons-dialog"
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Canons of Conduct</Typography>
          {mandatory && (
            <Typography variant="caption" color="error">
              * Mandatory Acceptance Required
            </Typography>
          )}
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          className="canons-content"
          dangerouslySetInnerHTML={{ __html: canons?.canons_of_conduct }}
          mb={2}
        />
        {mandatory && (
          <FormControlLabel
            control={
              <Checkbox
                checked={localAccepted}
                onChange={(e) => setLocalAccepted(e.target.checked)}
                color="primary"
                required
              />
            }
            label="I have read and agree to abide by these Canons of Conduct"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Close
        </Button>
        {mandatory ? (
          <Button
            onClick={handleAccept}
            color="primary"
            variant="contained"
            disabled={!localAccepted}
          >
            Accept and Continue
          </Button>
        ) : (
          <Button onClick={onClose} color="primary" variant="contained">
            Continue
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CanonsOfConductDialog;
